import { render, staticRenderFns } from "./MyAccountProfile.vue?vue&type=template&id=2a99f4f2&"
import script from "./MyAccountProfile.vue?vue&type=script&lang=ts&"
export * from "./MyAccountProfile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports